export enum RatesOption {
  ConstantValue = 0,
  PercentFromAmount = 1,
  PercentFromMinimalRate = 2,
  FiftyPercentFromAmount = 3,
  OneHundredPercentFromAmount = 4,
  NotSet = 5,
  PercentFromAmountAndLumpSum = 6,
}
